export class TimezoneConstants {
  public static readonly dbTimeZone: string = 'America/Denver';
}
